module.exports = __webpack_public_path__ + "static/media/Aoki_Concert20161203_DH_012.9d3f3529.jpg";